import React, { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-regular-svg-icons";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Button, IconButton } from "../Buttons";

const FileUpload = ({
  label = "Attachment",
  files = [],
  onChange,
  onDelete,
  required = false,
  multiple = true,
  accept = "*",
  mode = "add", // "add" or "edit"
  className = "",
  style = {},
  disabled = false,
}) => {
  // console.log("files", files);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    if (onChange) {
      onChange(selectedFiles);
    }
    // Reset input value to allow selecting the same file again
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleDeleteFile = (index) => {
    if (onDelete) {
      onDelete(index);
    }
  };

  const handleUploadClick = () => {
    if (disabled) return;
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div className={className} style={style}>
      <div className="form-group mt-4">
        <label className="block font-semibold" style={{ fontWeight: "bold" }}>
          {label}
          {required && (
            <span className="required" style={{ marginLeft: "-0.5px", fontSize: "15px" }}>
              *
            </span>
          )}
        </label>

        <div
          style={{
            border: "1px solid #DEE2E6",
            padding: "10px 20px",
            borderRadius: "6px",
          }}
        >
          <div
            style={{
              borderRadius: "4px",
              textAlign: "center",
            }}
          >
            <input
              type="file"
              ref={fileInputRef}
              className="hidden"
              onChange={handleFileChange}
              style={{ display: "none" }}
              multiple={multiple}
              accept={accept}
              disabled={disabled}
            />

            <Button
              type="button"
              onClick={handleUploadClick}
              disabled={disabled}
              title={disabled ? "You do not have permission to upload files." : undefined}
              style={{
                opacity: disabled ? 0.5 : 1,
                cursor: disabled ? "not-allowed" : "pointer",
                fontSize: "14px",
              }}
              className="add-row-button"
              size="sm"
              icon={
                <svg
                  width="17"
                  height="15"
                  viewBox="0 0 17 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 9.45021C1.13261 9.45021 1.25979 9.50289 1.35355 9.59666C1.44732 9.69042 1.5 9.8176 1.5 9.95021V12.4502C1.5 12.7154 1.60536 12.9698 1.79289 13.1573C1.98043 13.3449 2.23478 13.4502 2.5 13.4502H14.5C14.7652 13.4502 15.0196 13.3449 15.2071 13.1573C15.3946 12.9698 15.5 12.7154 15.5 12.4502V9.95021C15.5 9.8176 15.5527 9.69042 15.6464 9.59666C15.7402 9.50289 15.8674 9.45021 16 9.45021C16.1326 9.45021 16.2598 9.50289 16.3536 9.59666C16.4473 9.69042 16.5 9.8176 16.5 9.95021V12.4502C16.5 12.9806 16.2893 13.4894 15.9142 13.8644C15.5391 14.2395 15.0304 14.4502 14.5 14.4502H2.5C1.96957 14.4502 1.46086 14.2395 1.08579 13.8644C0.710714 13.4894 0.5 12.9806 0.5 12.4502V9.95021C0.5 9.8176 0.552678 9.69042 0.646447 9.59666C0.740215 9.50289 0.867392 9.45021 1 9.45021Z"
                    fill="currentColor"
                  />
                  <path
                    d="M8.146 0.69621C8.19245 0.649647 8.24762 0.612704 8.30837 0.587498C8.36911 0.562291 8.43423 0.549316 8.5 0.549316C8.56577 0.549316 8.63089 0.562291 8.69163 0.587498C8.75238 0.612704 8.80755 0.649647 8.854 0.69621L11.854 3.69621C11.9479 3.7901 12.0006 3.91743 12.0006 4.05021C12.0006 4.18299 11.9479 4.31032 11.854 4.40421C11.7601 4.4981 11.6328 4.55084 11.5 4.55084C11.3672 4.55084 11.2399 4.4981 11.146 4.40421L9 2.25721V11.0502C9 11.1828 8.94732 11.31 8.85355 11.4038C8.75979 11.4975 8.63261 11.5502 8.5 11.5502C8.36739 11.5502 8.24021 11.4975 8.14645 11.4038C8.05268 11.31 8 11.1828 8 11.0502V2.25721L5.854 4.40421C5.80751 4.4507 5.75232 4.48757 5.69158 4.51273C5.63084 4.53789 5.56574 4.55084 5.5 4.55084C5.43426 4.55084 5.36916 4.53789 5.30842 4.51273C5.24768 4.48757 5.19249 4.4507 5.146 4.40421C5.09951 4.35772 5.06264 4.30253 5.03748 4.24179C5.01232 4.18105 4.99937 4.11595 4.99937 4.05021C4.99937 3.98447 5.01232 3.91937 5.03748 3.85863C5.06264 3.79789 5.09951 3.7427 5.146 3.69621L8.146 0.69621Z"
                    fill="currentColor"
                  />
                </svg>
              }
              iconPosition="left"
              variant="gray"
            >
              Upload
            </Button>
          </div>

          {files.map((file, index) => (
            <div
              key={index}
              style={{
                border: "1px solid #DEE2E6",
                padding: "10px",
                marginTop: "10px",
                borderRadius: "4px",
                width: "30%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  color: "#0d6efd",
                  margin: 0,
                  display: "flex",
                  alignItems: "center",
                  maxWidth: "75%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                title={file.name || file.fileName || "Unnamed file"}
              >
                <FontAwesomeIcon
                  icon={faFile}
                  style={{
                    marginRight: "8px",
                    fontSize: "20px",
                    flexShrink: 0,
                  }}
                />
                {file.name || file.fileName || "Unnamed file"}
              </p>
              <IconButton
                icon={mode === "edit" ? <FontAwesomeIcon icon={faTrashCan} /> : "✕"}
                onClick={() => handleDeleteFile(index)}
                variant="link"
                disabled={disabled}
                title={disabled ? "You do not have permission to delete files." : undefined}
                style={{
                  fontSize: "16px",
                  color: "red",
                  opacity: disabled ? 0.5 : 1,
                  cursor: disabled ? "not-allowed" : "pointer",
                  pointerEvents: disabled ? "none" : "auto",
                }}
                ariaLabel="Delete file"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FileUpload;

